module.exports = __webpack_public_path__ + "img/4.3c7d33c4.png";